module.exports = __webpack_public_path__ + "static/logo-b35cea883f828636e550456c7b1e3384.png";